import React from "react";
import classNames from "classnames";

type AuthInputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  error?: string;
  invalid?: boolean;
};

// Lifted out of LoginForm so the signup flow renders identical fields.
export const AuthInput = React.forwardRef<HTMLInputElement, AuthInputProps>(
  ({ error, invalid, className, ...inputProps }, ref) => (
    <div className={classNames("w-full", className, { "border border-accent-red-450 rounded-[3px]": error || invalid })}>
      {error && <div className="mb-[3px] text-[14px] font-[500] text-accent-red-450">{error}</div>}
      <input
        ref={ref}
        className="h-[45px] w-full max-w-[300px] pl-4 pr-[9px] rounded-[3px] border-0 bg-[rgba(7,7,32,0.2)] xs:bg-[rgba(7,7,32,0.2)] max-sm:bg-purple-100 text-[16px] font-[500] text-white placeholder:text-lavender-50 placeholder:font-normal focus:outline-none focus:border-0"
        {...inputProps}
      />
    </div>
  ),
);
